import { offset } from "@floating-ui/react";

/** Nudge calendar toward the input (default translateY ~46px → ~35px for bottom-start). */
export const bottomStartDatePickerPopperModifiers = [offset({ mainAxis: -11 })];
